import { Route, Switch, matchPath, useLocation } from 'react-router-dom';
import APP_ROUTES from '../../../constants/app-routes';
import LazyLayout from '../../../layouts/lazy';
import React from 'react';
import SecondaryLayout from '../../../layouts/secondary';
import lazyDependencies from './index.lazy';

//

function UnauthenticatedRoutes() {
  const isOnStandaloneAssessmentRoute = Boolean(
    matchPath(useLocation().pathname, { path: '/assessment/' })
  );

  //
  // Render

  return (
    <LazyLayout layout={SecondaryLayout} withoutLabBranding={isOnStandaloneAssessmentRoute}>
      <Switch>
        <Route exact path={APP_ROUTES.oops}>
          <lazyDependencies.OopsPage />
        </Route>

        <Route exact path={[APP_ROUTES.studentSkillAnswers, APP_ROUTES.studentAssignmentAnswers]}>
          <lazyDependencies.SkillAnswersPage />
        </Route>

        <Route exact path={APP_ROUTES.skillPreview}>
          <lazyDependencies.SkillPreviewPage />
        </Route>

        <Route path={APP_ROUTES.standaloneAssessment}>
          <lazyDependencies.StandaloneAssessmentPage />
        </Route>

        <Route exact path={APP_ROUTES.standardsResults}>
          <lazyDependencies.StandardsResultsPage />
        </Route>

        <Route exact path={APP_ROUTES.unsupportedRole}>
          <lazyDependencies.UnsupportedRolePage />
        </Route>
      </Switch>
    </LazyLayout>
  );
}

// Exports
// -------

export default UnauthenticatedRoutes;
